import React from 'react'

function SectionThree() {
    return ( 
            <div className='container '>
                <h6 className='mb-6 text-sm text-white header-font'>ABOUT THE SHOP</h6 >
                <div className="text-sm text-gray-500 ">
                    <div >
                        <div className="mt-4"><span className='font-medium text-base '>STELLARE BIJOUX</span> </div>
                        <div className="mt-4"><span className='font-medium text-base '>Registered New York Address:</span> <span> 580,Fith Ave., Suite 2903 , New York , NY 10036 , USA</span></div>
                        <div className="mt-4"><p>Stellare bijoux is an USA recognized premium apparel brand for men and women . The brand has become a trendsetter of USA men's and women's jewelry which are made up of high quality  material with various unique styles and designs.</p>
                        </div>
                    </div>
                </div>
            </div>
    )
}

export default SectionThree
